import styled from 'styled-components'

export const Container = styled.div`
  h1 {
    margin-bottom: 0;
  }
  > :first-child {
    padding: 0;
    margin: 0.5rem 0;
    div {
      margin-bottom: -1rem;
      margin-right: 1rem;
    }
  }
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0.25rem 0;
    svg {
      width: 2rem;
      height: 2rem;
    }
    > div {
      position: relative;
    }
    span {
      background: red;
      padding: 0.2rem;
      border-radius: 50%;
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
    }

    a {
      padding: 0.3rem 0.6rem;
      font-size: 1.25rem;
      background: ${({ theme }) => theme.colors.gray800};

      &.active {
        background: ${({ theme }) => theme.colors.red};
      }
    }
  }
`
